module.exports = __webpack_public_path__ + "af.no2.38a0ddfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/af.no2.jpg
// module id = xROz
// module chunks = 0